import React from "react";
import EyeNoData from "../components/Nav & Header/Eye";
import { Link } from "react-router-dom";
function NotFound() {
  return (
    <div className="full-width w-full height-auto h-[100vh] absolute inset-0 m-auto ">
      <div className="h-full w-full flex lg:flex-row flex-col justify-center items-center">
        <div className="bg-primary h-full py-20  w-full lg:w-1/2 flex NotFound-col justify-center items-center z-50">
          <div>
            <h1 className="text-[8rem] md:text-[13rem]  2xl:text-[18rem] font-SoraS text-tertiary">
              4
            </h1>
          </div>
          <div className="Not_found">
            <EyeNoData />
          </div>
          <div>
            <h1 className="text-[8rem] md:text-[13rem]  2xl:text-[18rem] font-SoraS text-tertiary">
              4
            </h1>
          </div>
        </div>
        <div className="px-[15px] h-full  py-20 md:px-0 w-full lg:w-1/2 m-auto flex justify-center items-center flex-col text-center z-50">
          <h2 className="font-SoraS text-tertiary uppercase text-[30px] md:text-[40px]">
            Page not found
          </h2>
          <p className="max-w-[500px] font-SoraL text-tertiary text-[14px] sm:text-[16px] md:text-[20px] capitalize">
            The page you are looking for doesn't exist or has been moved.
          </p>
          <Link className="my-8" to="/">
            <button className=" text-primary font-SoraR capitalize Purple-btn-effect relative bg-tertiary h-[52px] w-[130px]">
              Home
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
